var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.$t("方案对比"),
      width: 800,
      closable: false,
      maskClosable: false
    },
    model: {
      value: _vm.comparisonVisible,
      callback: function ($$v) {
        _vm.comparisonVisible = $$v;
      },
      expression: "comparisonVisible"
    }
  }, [_c("a-table", {
    attrs: {
      pagination: false,
      size: "small",
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.data,
      align: "center",
      rowKey: "id"
    }
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.closeAdd
    }
  }, [_vm._v(_vm._s(_vm.$t("关闭")))])], 1)], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };